import { placeholderPattern } from './placeholder';

/**
 * Percent-encodes a query value while leaving `{{field}}` placeholders readable,
 * so they can still be matched once the form values are known.
 */
export const encodeQueryValue = (value: string): string =>
  value
    .split(placeholderPattern)
    .map((part, index) =>
      index % 2 === 0 ? encodeURIComponent(part) : `{{${part}}}`,
    )
    .join('');
